var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BBGoogleMapLoader"},[_c('div',{ref:"googleMap",staticClass:"google-maps"}),_vm._v(" "),(_vm.google && _vm.map && _vm.gmapsMarkers)?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map,"gmapsMarkers":_vm.gmapsMarkers})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }